import React, { useState } from 'react';
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '70%',
        padding: '20px 0',
        '& >*': {
            width: '100%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            padding: '10px 0'
        }
    }
}));

export const Pincode = ({ value, onComplete, ...restProps }) => {
    const classes = useStyles();
    const [error, setError] = useState(false)
    const [errorText, setErrorText] = useState(false)
    const [pincode, setPincode] = useState('')

    const onChange = (event) => {
        const regex = /^[1-9][0-9]{5}$/
        setPincode(event.target.value)
        onComplete(event)
        if (regex.test(event.target.value)) {
            setError(false)
        } else {
            setError(true)
        }
    }

    const handleError = () => {
        const regex = /^[1-9][0-9]{5}$/
        if (!regex.test(pincode)) {
            setError(true)
            setErrorText('This is not a valid Pincode')
        } else {
            setError(false)
            setErrorText('')
        }
    }
    return (
        <div className={classes.formControl}>
            <TextField
                label={'Clinic/Hospital Pincode'}
                name="pincode"
                {...restProps}
                error={error}
                onChange={onChange}
                helperText={errorText}
                onBlur={()=> handleError()}
            />
        </div>
    )
}
